export var BarGraphDirection;
(function (BarGraphDirection) {
    BarGraphDirection[BarGraphDirection["DownToUp"] = 0] = "DownToUp";
    BarGraphDirection[BarGraphDirection["UpToDown"] = 1] = "UpToDown";
    BarGraphDirection[BarGraphDirection["LeftToRight"] = 2] = "LeftToRight";
    BarGraphDirection[BarGraphDirection["RightToLeft"] = 3] = "RightToLeft";
})(BarGraphDirection || (BarGraphDirection = {}));
